import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Request {
  clientId: PilotId;
  condition: 'failed' | 'unprocessed' | 'all' | 'stop';
  algorithms: string[];
}

export const reprocessAlgorithms = async ({
  clientId,
  condition,
  algorithms,
}: Request): Promise<boolean> => {
  await pilot.patch(`client/${clientId}/reprocess-documents/`, {
    algorithms,
    condition,
  });
  return true;
};
